import type { AnalyticsResponse } from "@surevai/contracts";

const API_BASE = (import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, "");

async function read<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const body = await response.json().catch(() => ({})) as { message?: string };
    throw new Error(body.message || "The request could not be completed.");
  }
  return response.json() as Promise<T>;
}

export async function recordDailyVisit(): Promise<void> {
  const day = new Date().toISOString().slice(0, 10);
  const key = `surevai-visit-${day}`;
  try { if (window.localStorage.getItem(key)) return; } catch { /* Counting still works without local storage. */ }
  const response = await fetch(`${API_BASE}/api/v1/analytics/visit`, { method: "POST", credentials: "omit" });
  if (!response.ok) return;
  try { window.localStorage.setItem(key, "1"); } catch { /* The server de-duplicates privacy-safe visitor hashes. */ }
}

export async function adminSession(): Promise<{ authenticated: true; email: string }> {
  return read(await fetch(`${API_BASE}/api/v1/admin/session`, { credentials: "include", cache: "no-store" }));
}

export async function adminLogin(email: string, password: string): Promise<{ authenticated: true; email: string }> {
  return read(await fetch(`${API_BASE}/api/v1/admin/login`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  }));
}

export async function adminLogout(): Promise<void> {
  await read(await fetch(`${API_BASE}/api/v1/admin/logout`, { method: "POST", credentials: "include" }));
}

export async function getAdminAnalytics(days: 7 | 30 | 90): Promise<AnalyticsResponse> {
  return read(await fetch(`${API_BASE}/api/v1/admin/analytics?days=${days}`, { credentials: "include", cache: "no-store" }));
}
